export const API_HOST = process.env.REACT_APP_API_HOST;
export const SOCKET_HOST = process.env.REACT_APP_SOCKET_HOST;
export const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH;
export const WEBCHAT_SOCKET_PATH = process.env.REACT_APP_WEBCHAT_SOCKET_PATH;
export const WEB_CHAT_APP_URL = process.env.REACT_APP_WEB_CHAT_APP_URL;
export const PRODUCT = process.env.REACT_APP_PRODUCT;
export const WEBCHAT_HOST = process.env.REACT_APP_WEBCHAT_HOST;

export const NLU_HOST = process.env.REACT_APP_NLU_HOST;
export const WEB_HOST = process.env.REACT_APP_WEB_HOST;

export const KEEPER_HOST = process.env.REACT_APP_KEEPER_HOST;

export const GA_TRACKING_KEY = process.env.REACT_APP_GA_TRACKING_KEY;
export const DISABLE_GA = process.env.REACT_APP_DISABLE_GA === "true" && !!GA_TRACKING_KEY;
export const DISABLE_BUGSNAG = process.env.REACT_APP_DISABLE_BUGSNAG === "true";
export const DISABLE_INTEGRATION_FACEBOOK = process.env.REACT_APP_DISABLE_INTEGRATION_FACEBOOK === "true";
export const DISABLE_INTEGRATION_INSTAGRAM = process.env.REACT_APP_DISABLE_INTEGRATION_INSTAGRAM === "true";
export const DISABLE_INTEGRATION_KAKAOTALK = process.env.REACT_APP_DISABLE_INTEGRATION_KAKAOTALK === "true";
export const DISABLE_INTEGRATION_NAVERTALK = process.env.REACT_APP_DISABLE_INTEGRATION_NAVERTALK === "true";
export const DISABLE_INTEGRATION_LINE = process.env.REACT_APP_DISABLE_INTEGRATION_LINE === "true";
export const DISABLE_INTEGRATION_SLACK = process.env.REACT_APP_DISABLE_INTEGRATION_SLACK === "true";
export const DISABLE_INTEGRATION_JANDI = process.env.REACT_APP_DISABLE_INTEGRATION_JANDI === "true";
export const CM_CTX = process.env.REACT_APP_CM_CTX;

export const QUERY_DEVTOOLS = process.env.REACT_APP_QUERY_DEVTOOLS === "true";
